<template>
  <app-layout>
    <div>
      <div class="px-12">
        <bread-nav :pages="pages"></bread-nav>
      </div>
      <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
        <update-team-name-form :team="team" :permissions="permissions"/>
        <team-member-manager class="mt-10 sm:mt-0"
                             :team="team"
                             :available-roles="availableRoles"
                             :user-permissions="permissions"/>

        <template v-if="permissions.canDeleteTeam &&  !team.personal_team">
          <jet-section-border/>

          <delete-team-form class="mt-10 sm:mt-0" :team="team"/>
        </template>
      </div>
    </div>
  </app-layout>
</template>

<script>
import TeamMemberManager from './TeamMemberManager'
import AppLayout from '@/Layouts/AppLayout'
import DeleteTeamForm from './DeleteTeamForm'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import UpdateTeamNameForm from './UpdateTeamNameForm'
import BreadNav from "@/Components/BreadNav/BreadNav";

export default {
  props: [
    'team',
    'availableRoles',
    'permissions',
  ],
  data(){

    return {
      pages:[]
    }
  },
  mounted() {
    this.pages = [
      {name: 'Team Management', href: '#', current: false},
      {name: 'Team ' +  this.$page.props.user.current_team.name + ' Settings', href: '#', current: true},
    ]
  },
  components: {
    BreadNav,
    AppLayout,
    DeleteTeamForm,
    JetSectionBorder,
    TeamMemberManager,
    UpdateTeamNameForm,
  },
  setup(){
    return {
    }
  }
}
</script>
